// @ is an alias to /src
import ApiService from '@/services/ApiService'

export const namespaced = true

export const actions = {
  fetchTimeAttendanceOffsiteGrants(_, payload) {
    return ApiService.fetchTimeAttendanceOffsiteGrants(payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        throw error
      })
  },
  fetchOffsiteGrantCompanyLocations(_, payload) {
    return ApiService.fetchOffsiteGrantCompanyLocations(payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        throw error
      })
  },
  addOffsiteGrantCompanyLocation(_, payload) {
    return ApiService.addOffsiteGrantCompanyLocation(payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        throw error
      })
  },
  editOffsiteGrantCompanyLocation(_, payload) {
    return ApiService.editOffsiteGrantCompanyLocation(payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        throw error
      })
  },
  editCompanyLocationSchedule(_, payload) {
    return ApiService.editCompanyLocationSchedule(payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        throw error
      })
  },
  addCompanyLocationSchedule(_, payload) {
    return ApiService.addCompanyLocationSchedule(payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        throw error
      })
  },
  deleteOffsiteGrantCompanyLocation(_, payload) {
    return ApiService.deleteOffsiteGrantCompanyLocation(payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        throw error
      })
  },
  deleteCompanyLocationSchedule(_, payload) {
    return ApiService.deleteCompanyLocationSchedule(payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        throw error
      })
  },
  deleteClientSiteSchedule(_, payload) {
    return ApiService.deleteClientSiteSchedule(payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        throw error
      })
  },
  fetchOffsiteGrantClientSiteLocations(_, payload) {
    return ApiService.fetchOffsiteGrantClientSiteLocations(payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        throw error
      })
  },
  addOffsiteGrantClientSiteLocation(_, payload) {
    return ApiService.addOffsiteGrantClientSiteLocation(payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        throw error
      })
  },
  editOffsiteGrantClientSiteLocation(_, payload) {
    return ApiService.editOffsiteGrantClientSiteLocation(payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        throw error
      })
  },
  addClientSiteSchedule(_, payload) {
    return ApiService.addClientSiteSchedule(payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        throw error
      })
  },
  editClientSiteSchedule(_, payload) {
    return ApiService.editClientSiteSchedule(payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        throw error
      })
  },
  deleteOffsiteGrantClientSiteLocation(_, payload) {
    return ApiService.deleteOffsiteGrantClientSiteLocation(payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        throw error
      })
  },
  editTimeAttendanceOffsiteGrant(_, payload) {
    return ApiService.editTimeAttendanceOffsiteGrant(payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        throw error
      })
  },
  addWfhLocationSchedule(_, payload) {
    return ApiService.addWfhLocationSchedule(payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        throw error
      })
  },
  editWfhLocationSchedule(_, payload) {
    return ApiService.editWfhLocationSchedule(payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        throw error
      })
  },
  deleteWfhLocationSchedule(_, payload) {
    return ApiService.deleteWfhLocationSchedule(payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        throw error
      })
  },
}
